import React, { Component } from 'react';
import PropTypes from 'prop-types';
import muiThemeable from 'material-ui/styles/muiThemeable';
import { Table, TableHeader, TableRow } from 'material-ui/Table';
import DatagridHeaderCell from 'admin-on-rest/lib/mui/list/DatagridHeaderCell';
import DatagridBodyWithContentRow from './DatagridBodyWithContentRow';

const defaultStyles = {
    table: {
        tableLayout: 'auto',
    },
    tbody: {
        height: 'inherit',
    },
    header: {
        th: {
            padding: 0,
        },
        'th:first-child': {
            padding: '0 0 0 12px',
        },
    },
    cell: {
        td: {
            padding: '0 12px',
            whiteSpace: 'normal',
        },
        'td:first-child': {
            padding: '0 12px 0 16px',
            whiteSpace: 'normal',
        },
    },
};

/**
 * The DatagridWithContentRow component duplicates the AOR Datagrid, which renders a list of records as a table.
 * It loads a DatagridBodyWithContentRow, which displays list items and an additional row for full-width data.
 *
 */
class DatagridWithContentRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    updateSort = event => {
        event.stopPropagation();
        this.props.setSort(event.currentTarget.dataset.sort);
    };

    render() {
        const {
            resource,
            children,
            columns,
            contentKey,
            ids,
            isLoading,
            data,
            currentSort,
            basePath,
            styles = defaultStyles,
            muiTheme,
            rowStyle,
            options,
            headerOptions,
            bodyOptions,
            rowOptions,
            uniqueKey,
        } = this.props;
        return (
            <Table
                style={options && options.fixedHeader ? null : styles.table}
                fixedHeader={false}
                {...options}
            >
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    {...headerOptions}
                >
                    <TableRow style={muiTheme.tableRow}>
                        {React.Children.map(
                            children,
                            (field, index) =>
                                field ? (
                                    <DatagridHeaderCell
                                        key={field.props.source || index}
                                        field={field}
                                        defaultStyle={
                                            index === 0 ? (
                                                styles.header['th:first-child']
                                            ) : (
                                                styles.header.th
                                            )
                                        }
                                        currentSort={currentSort}
                                        isSorting={
                                            field.props.source ===
                                            currentSort.field
                                        }
                                        updateSort={this.updateSort}
                                        resource={resource}
                                    />
                                ) : null
                        )}
                    </TableRow>
                </TableHeader>
                <DatagridBodyWithContentRow
                    resource={resource}
                    ids={ids}
                    columns={columns}
                    contentKey={contentKey}
                    data={data}
                    basePath={basePath}
                    styles={styles}
                    rowStyle={rowStyle}
                    isLoading={isLoading}
                    options={bodyOptions}
                    rowOptions={rowOptions}
                    uniqueKey={uniqueKey}
                >
                    {children}
                </DatagridBodyWithContentRow>
            </Table>
        );
    }
}

DatagridWithContentRow.propTypes = {
    basePath: PropTypes.string,
    bodyOptions: PropTypes.object,
    columns: PropTypes.number,
    contentKey: PropTypes.string.isRequired,
    currentSort: PropTypes.shape({
        sort: PropTypes.string,
        order: PropTypes.string,
    }),
    data: PropTypes.object.isRequired,
    headerOptions: PropTypes.object,
    ids: PropTypes.arrayOf(PropTypes.any).isRequired,
    isLoading: PropTypes.bool,
    muiTheme: PropTypes.object,
    options: PropTypes.object,
    resource: PropTypes.string,
    rowOptions: PropTypes.object,
    rowStyle: PropTypes.func,
    setSort: PropTypes.func,
    styles: PropTypes.object,
    uniqueKey: PropTypes.string,
};

DatagridWithContentRow.defaultProps = {
    columns: 1,
    contentKey: 'name',
    data: {},
    ids: [],
    uniqueKey: 'id',
};

export default muiThemeable()(DatagridWithContentRow);



// WEBPACK FOOTER //
// ./src/Fuse/admin/DatagridWithContentRow.js